import React, { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import { api } from "@/lib/api";
import { downloadAuth, eur, itDate } from "@/lib/download";

export const INVOICE_TYPES = { subscription: "Abbonamento", trial: "Quota prova 2 mesi", store_commission: "Commissione Store", package: "Pacchetto Evento Chiavi in Mano" };

export const InvoicesCard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/me/invoices").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div className="mt-8 card-premium p-6" data-testid="my-invoices">
      <h3 className="font-display text-xl font-bold flex items-center gap-2 mb-1"><FileText className="w-5 h-5 text-gold"/>Le mie fatture</h3>
      <p className="text-xs text-slate-500 mb-4">Fatture generate in modalità simulazione (PDF). La versione elettronica XML arriverà in seguito.</p>
      <div className="divide-y divide-slate-100">
        {rows.map((r) => (
          <div key={r.id} className="py-2.5 flex items-center justify-between gap-3 text-sm" data-testid={`my-invoice-${r.number}`}>
            <div><b>N. {r.number}</b> · {INVOICE_TYPES[r.type]} · {itDate(r.date)}</div>
            <div className="flex items-center gap-3"><b>{eur(r.total)}</b>
              <button onClick={() => downloadAuth(`/invoices/${r.id}/pdf`, `fattura-${r.number.replace("/", "-")}.pdf`)} data-testid={`my-invoice-pdf-${r.number}`} className="btn-pill-outline !py-1.5 !px-3 text-xs"><Download className="w-3.5 h-3.5"/>PDF</button></div>
          </div>
        ))}
      </div>
    </div>
  );
};
